import {Mutation} from './mutation-types'
import {showWarning} from "../utils";
export default {

    // Production Line
    [Mutation.CREATE_PRODUCTION_LINE] (state, {productionLine}) {
        return state.productionLines.push(productionLine)
    },
    // Stations
    [Mutation.CREATE_STATION] (state, {station, productionLineId}) {
        var index = state.productionLines.findIndex(l => l.id === productionLineId)

        if(index === -1)
            return showWarning(`Imposible añadir estacion en la linea (id ${productionLineId})`)

        return state.productionLines[index].stations.push(station)
    },
    // Machines
    [Mutation.CREATE_MACHINE] (state, {machine, stationId}) {
        let stationIndex = -1,
            productionLineIndex = -1;
        state.productionLines.some(function(productionLine, i) {
            let temp = productionLine.stations.findIndex(e => e.id === stationId)
            if(temp !== -1) {
                productionLineIndex = i;
                stationIndex = temp;
                return true;
            }
        })

        if( stationIndex  === -1 || productionLineIndex === -1)
            return showWarning(`Estacion no encontrada (id ${stationId})`)

        return state.productionLines[productionLineIndex].stations[stationIndex].push(machine)
    },

    //Machine Operation Pivots
    [Mutation.CREATE_MACHINE_OPERATION_PIVOT] (state, {machineOperationPivot}){
        if(!machineOperationPivot)
            return showWarning('Pivote de maquinas y operaciones invalido, imposible crear')
        if(state.machineOperationPivots.findIndex(m => m.id == machineOperationPivot.id) != -1)
            return showWarning(`Pivote de maquinas y operaciones ya existente (id ${machineOperationPivot.id})`)

        state.machineOperationPivots.push(machineOperationPivot);
        return state.machineOperationPivots;
    },
    [Mutation.UPDATE_MACHINE_OPERATION_PIVOT] (state, {machineOperationPivot}){
        if(!machineOperationPivot)
            return showWarning('Pivote de maquinas y operaciones invalido, imposible actualizar')

        let machineOperationPivotToUpdate = state.machineOperationPivots.find(o => o.id == machineOperationPivot.id)
        if(!machineOperationPivotToUpdate)
            return showWarning(`Pivote de maquinas y operaciones no existente (id ${machineOperationPivot.id})`)

        state.machineOperationPivots[state.machineOperationPivots.findIndex(o => o.id == machineOperationPivot.id)] = {
            ...machineOperationPivotToUpdate,
            ...machineOperationPivot
        }
        return state.machineOperationPivots;
    },
    [Mutation.DELETE_MACHINE_OPERATION_PIVOT] (state, {machineOperationPivotId}){
        if(isNaN(machineOperationPivotId))
            return showWarning('Pivote de maquinas y operaciones invalido, no es numerico', machineOperationPivotId);
        let machineOperationPivotToDeleteIndex = state.machineOperationPivots.findIndex(m => m.id == machineOperationPivotId);
        if(machineOperationPivotToDeleteIndex == -1)
            return showWarning(`Pivote de maquinas y operaciones no encontrado (id ${machineOperationPivotId})`)

        state.machineOperationPivots.splice(machineOperationPivotToDeleteIndex, 1);
        return  state.machineOperationPivots;
    },

    // Operation Groups
    [Mutation.CREATE_OPERATION_GROUP] (state, {operationGroup}){
        if(!operationGroup)
            return showWarning('Grupo de operaciones invalido, imposible crear')
        if(state.operationGroups.findIndex(o => o.id == operationGroup.id) != -1)
            return showWarning(`Grupo de operacion ya existente (id ${operationGroup.id})`)

        state.operationGroups.push(operationGroup);
        return state.operationGroups;
    },
    [Mutation.UPDATE_OPERATION_GROUP] (state, {operationGroup}){
        if(!operationGroup)
            return showWarning('Grupo de operaciones invalido, imposible actualizar')

        let operationGroupToUpdate = state.operationGroups.find(o => o.id == operationGroup.id)
        if(!operationGroupToUpdate)
            return showWarning(`Grupo de operacion no existente (id ${operationGroup.id})`)

        state.operationGroups[state.operationGroups.findIndex(o => o.id == operationGroup.id)] = {
            ...operationGroupToUpdate,
            ...operationGroup
        }
        return state.operationGroups;
    },
    [Mutation.DELETE_OPERATION_GROUP] (state, {operationGroupId}){
        if(isNaN(operationGroupId))
            return showWarning('Id del grupo de operacion invalido, no es numerico', operationGroupId);
        let operationGroupToDeleteIndex = state.operationGroups.findIndex(o => o.id == operationGroupId);
        if(operationGroupToDeleteIndex == -1)
            return showWarning(`Grupo de operaciones no encontrado (id ${operationGroupId})`)

        state.operationGroups.splice(operationGroupToDeleteIndex, 1);
        return  state.operationGroups;
    },

    // Operations (Fron Operation Groups)
    [Mutation.CREATE_OPERATION] (state, {operation}) {
        if(!operation)
            return showWarning('Operacion invalida, imposible crear');
        let operationGroupIndex = state.operationGroups.findIndex(o => o.id == operation.operation_group_id);
        if(operationGroupIndex == -1)
            return showWarning(`Grupo de operaciones no existente (id ${operation.operation_group_id})`)
        if(state.operationGroups[operationGroupIndex].operations().findIndex(o => o.id == operation.id) != -1)
            return showWarning(`Operacion ya existente (id ${operation.id})`);

        state.operationGroups[operationGroupIndex].push(operation);
        return state.operationGroups;
    },
    [Mutation.UPDATE_OPERATION] (state, {operation}) {
        if(!operation)
            return showWarning('Operacion invalida, imposible actualizar')
        let operationGroupIndex = state.operationGroups.findIndex(o => o.id == operation.operation_group_id);
        if(operationGroupIndex == -1)
            return showWarning(`Grupo de operaciones no existente (id ${operation.operation_group_id})`)
        let operationToUpdate = state.operationGroups[operationGroupIndex].find(o => o.id == operation.id);
        let operationToUpdateIndex = state.operationGroups[operationGroupIndex].findIndex(o => o.id == operation.id);
        if(!operationToUpdate)
            return showWarning(`Operacion no existente (id ${operation.id})`)

        state.operationGroups[operationGroupIndex].operations[operationToUpdateIndex] = {
            ...operationToUpdate,
            ...operation
        }
        return state.operationgroups;
    },
    [Mutation.DELETE_OPERATION] (state, {operationId}) {
        if(isNaN(operationId))
            return showWarning('Id de operacion invalido, no numerico', operationId)
        let operationGroupIndex = state.operationGroups.findIndex(o => o.id == operation.operation_group_id);
        if(operationGroupIndex == -1)
            return showWarning(`Grupo de operaciones no existente (id ${operation.operation_group_id})`)
        let operationToDeleteIndex = state.operationGroups[operationGroupIndex].findIndex(o => o.id == operationId)
        if(operationToDeleteIndex == -1)
            return showWarning(`Operacion no encontrada (id ${operationId} )`)

        state.operationGroups[operationGroupIndex].operations.splice(operationToDeleteIndex, 1);
        return state.operationGroups;
    },

    // Reference Groups
    [Mutation.CREATE_REFERENCE_GROUP] (state, {referenceGroup}) {
        if(!referenceGroup)
            return showWarning('Grupo de referencias invalida, imposible crear')
        if(state.referenceGroups.findIndex(r => r.id == referenceGroup.id) != -1)
            return showWarning(`Grupo de referencias ya existente (id ${referenceGroup.id})`)

        state.referenceGroups.push(referenceGroup);
        return state.referenceGroups;

    },
    [Mutation.UPDATE_REFERENCE_GROUP] (state, {referenceGroup}) {
        if(!referenceGroup)
            return showWarning('Grupo de referencias invalida, imposible actualizar')
        let referenceGroupToUpdate = state.referenceGroups.find(r => r.id == referenceGroup.id);
        if( !referenceGroupToUpdate)
            return showWarning(`Grupo de referencias no existente (id ${referenceGroup.id})`)

        let index =state.referenceGroups.findIndex(r=> r.id == referenceGroupToUpdate.id);
        state.referenceGroups.splice(index, 1, {
            ...referenceGroupToUpdate,
            ...referenceGroup
        });
        return state.referenceGroups;
    },
    [Mutation.DELETE_REFERENCE_GROUP] (state, {referenceGroupId}) {
        if(isNaN(referenceGroupId))
            return showWarning('Id del grupo de referencias invalido, no es numerico', referenceGroupId)
        let referenceGroupToDeleteIndex = state.referenceGroups.findIndex(f => f.id == referenceGroupId);
        if(referenceGroupToDeleteIndex == -1)
            return showWarning(`Grupo de referencias no encontrada (id ${referenceGroupId})`)

        state.referenceGroups.splice(referenceGroupToDeleteIndex, 1);
        return state.referenceGroups;
    },

    // References
    [Mutation.CREATE_REFERENCE] (state, {reference}) {
        if (!reference)
            return showWarning('Referencia invalida, imposible crear')
        if(state.references.findIndex(r => r.id == reference.id) != -1 )
            return showWarning(`Referencia ya existente (id ${reference.id})`)

        state.references.push(reference);
        return state.references;
    },
    [Mutation.UPDATE_REFERENCE] (state, {reference}) {
        if (!reference)
            return showWarning('Referencia invalida, imposible crear');
        let referenceToUpdate = state.references.find(r => r.id == reference.id);
        if( !referenceToUpdate )
            return showWarning(`Referencia no existente (id ${reference.id})`)
        state.references[state.references.findIndex(r=>r.id == reference.id)] = {
            ...referenceToUpdate,
            ...reference
        }
        return state.references;
    },
    [Mutation.DELETE_REFERENCE] (state, {referenceId}) {
        if(isNaN(referenceId))
            return showWarning('Id de rederencia invalido, no es numerico', referenceId)
        let referenceToDeleteIndex = state.references.findIndex(r => r.id == referenceId)
        if(referenceToDeleteIndex == -1)
            showWarning(`Referencia no encontrada (id ${referenceId})`)

        state.references.splice(referenceToDeleteIndex, 1);
        return state.references;
    },

    // Magnitude Units
    [Mutation.CREATE_MAGNITUDE_UNIT] (state, {magnitudeUnit}) {
        if(!magnitudeUnit)
            return showWarning('Unidad de magnitud no valida')
        if(state.magnitudeUnits.findIndex(m => m.id == magnitudeUnit.id) != -1)
            return showWarning('Unidad de magnitud ya existente')

        state.magnitudeUnits.push(magnitudeUnit)
        return state.magnitudeUnits
    },
    [Mutation.DELETE_MAGNITUDE_UNIT] (state, {magnitudeUnitId}) {
        if(isNaN(magnitudeUnitId))
            return showWarning('Id de uniadad de magnitud no valido, no es numerico')
        let magnitudeUnitToDeleteIndex = state.magnitudeUnits.findIndex(m => m.id == magnitudeUnitId);
        if(magnitudeUnitToDeleteIndex == -1)
            return showWarning(`Unidad de magnitud no existente (id ${magnitudeUnitToDeleteIndex})`)

        state.magnitudeUnits.splice(magnitudeUnitToDeleteIndex, 1)
        return state.magnitudeUnits;
    },

    // Packagings
    [Mutation.CREATE_PACKAGING] (state, {packaging}) {
        if(!packaging)
            return showWarning('Empaquetado no valido, imposible crear')
        if(state.packagings.findIndex(p => p.id == packaging.id) != -1)
            return showWarning(`Empaquetado ya existente (id ${packaging.id})`)

        state.packagings.push(packaging)
        return state.packagings;
    },
    [Mutation.UPDATE_PACKAGING] (state, {packaging}) {
        if(!packaging)
            return showWarning('Empaquetado invalido, imposible actualizar')
        let packagingToUpdate = state.packagings.find(r => r.id == packaging.id);
        if( !packagingToUpdate)
            return showWarning(`Empaquetado no existente (id ${packaging.id})`)

        state.packagings[state.packagings.findIndex(r=> r.id == packagingToUpdate.id)] = {
            ...referenceGroupToUpdate,
            ...referenceGroup
        }
        return state.packagings;
    },
    [Mutation.DELETE_PACKAGING] (state, {packagingId}) {
        if(isNaN(packagingId))
            return showWarning('Id de empaquetado invalido, no numerico')
        let packagingToDeleteIndex = state.packagings.findIndex(p => p.id == packagingId)
        if(packagingToDeleteIndex == -1)
            return showWarning(`Empaquetado no encontrado (id ${packagingId})`)

        state.packagings.splice(packagingToDeleteIndex, 1)
        return state.packagings;
    },

    // Packaging Formats
    [Mutation.CREATE_PACKAGING_FORMAT] (state, {packagingFormat}) {
        if(!packagingFormat)
            return showWarning('Formato de empaquetado no valido, imposible crear')
        if(state.packagingFormats.findIndex(pf => pf.id == packagingFormat.id) != -1)
            return showWarning(`Formado de empaquetado ya existente (id ${packagingFormat.id})`)

        state.packagingFormats.push(packagingFormat);
        return state.packagingFormats;
    },
    [Mutation.DELETE_PACKAGING_FORMAT] (state, {packagingFormatId}) {
        if(isNaN(packagingFormatId))
            return showWarning('Id de formato de empaquetado no valido, no es numerico')
        let packagingFormatToDeleteIndex = state.packagingFormats.findIndex(pf => pf.id == packagingFormatId)
        if(packagingFormatToDeleteIndex == -1)
            return concols.warn(`Formato de empaquetado no existente (id ${packagingFormatId})`)

        state.packagingFormats.splice(packagingFormatToDeleteIndex, 1)
        return state.packagingFormats;
    },

    // Modals
    [Mutation.CREATE_MODAL] (state, {modal}) {
        if(!modal)
            return showWarning('Modal invalido')
        if(state.modals.findIndex(m => m.id == modal.id) != -1)
            return showWarning(`Modal ya existente (id ${modal.id})`)

        state.modals.push(modal)
        return state.modals;
    },
    [Mutation.DELETE_MODAL] (state, modalId) {
        if(isNaN(modalId))
            return showWarning('Id de modal invalido, no es numerico')
        let modalToDeleteIndex = state.modals.findIndex(m => m.id == modalId);

        state.modals.splice(modalToDeleteIndex, 1);
        return state.modals;

    },

    // User permissions
    [Mutation.INITIALIZE_USER_PERMISSIONS] (state, permissions) {
        if (!permissions) return false;
        state.userPermissions = permissions;
        return state.userPermissions;
    },

    [Mutation.UPDATE_IS_USER_SUPERADMIN] (state, isSuperAdmin) {
        state.isUserSuperadmin = isSuperAdmin;
        return state.isUserSuperadmin;
    },
    
    [Mutation.UPDATE_IS_USER_ADMIN] (state, isAdmin) {
        state.isUserAdmin = isAdmin;
        return state.isUserAdmin;
    },

    [Mutation.UPDATE_USERNAME] (state, username) {
        state.username = username;
        return state.username;
    }

}
